import Text, { TextColor } from '@/components/view/atoms/text/Text'
import MessageBar from '@/components/view/molecules/bar/MessageBar'

interface Props {
  message: string
}
const W2ModeMessage = ({ message }: Props) => {
  return (
    <MessageBar type='brand' fillIn>
      <span className='flex items-center gap-2'>
        <img src='/assets/w2-icon.png' alt='W2Commerceロゴ' className='h-5 w-5' />
        <Text size={14} weight='bold' color={TextColor.INFO}>
          W2Commerce完全連動モードが有効です
        </Text>
      </span>
      <Text size={12}>{message}</Text>
    </MessageBar>
  )
}

export default W2ModeMessage
